import Box from "components/Box";

import SectionContent from "entities/Memo/components/Sections/SectionContent";
import SectionHeader from "entities/Memo/components/Sections/SectionHeader";

interface IRisksAndMitigantsSection {
  title: string;
}

const RisksAndMitigantsSection = ({ title }: IRisksAndMitigantsSection) => (
  <Box>
    <SectionHeader label={title} />
    <SectionContent breakInside="avoid">
      <Box
        sx={{
          breakInside: "avoid",
        }}
      >
        <p>This is an example {title} text.</p>
      </Box>
    </SectionContent>
  </Box>
);

export default RisksAndMitigantsSection;
